import getStore from "store";

import { DEFAULT_REGION } from "common/static/regions";

import { getRegion } from "seneca-common/features/user/state";
import logError from "seneca-common/utils/sentry/logError";

export const REGION_SESSION_STORAGE_KEY = "seneca.region";

/**
 * This selector falls back to the default region where a region isn't set in user preferences.
 * (e.g. on app start-up, anonymous pages)
 */
export const getUserRegion = () =>
  getRegion(getStore().getState()) || DEFAULT_REGION;

export const setRegionInSessionStorage = (region: string) => {
  try {
    window.sessionStorage &&
      window.sessionStorage.setItem(REGION_SESSION_STORAGE_KEY, region);
  } catch (err: any) {
    logError(err, {
      message: "Could not set region in sessionStorage"
    });
  }
};

export const getRegionFromSessionStorage = () => {
  try {
    return (
      window.sessionStorage &&
      window.sessionStorage.getItem(REGION_SESSION_STORAGE_KEY)
    );
  } catch (err: any) {
    logError(err, {
      message: "Could not get region from sessionStorage"
    });
  }

  return null;
};
